import React from 'react';

import ErnCaptureForm from './organisms/ErnCaptureForm';

const mainContainerStyles = {
  margin: '0 auto',
  maxWidth: 768, // default width of container which will be parent of an iframe in Reaktor
};

function App() {
  return (
    <div style={mainContainerStyles}>
      <ErnCaptureForm />
    </div>
  );
}

export default App;
